import { docgenEnum } from '@polestar/component-warehouse-react/helpers/docgenInterface';
var DataLayerEvent;
(function (DataLayerEvent) {
    DataLayerEvent["LINK_CLICK"] = "click";
    DataLayerEvent["SECTION_VISIBLE"] = "section.elementVisibility";
})(DataLayerEvent || (DataLayerEvent = {}));
/**
 * @internal
 */
export const DataLayerEventInterface = docgenEnum('DataLayerEvent', DataLayerEvent);
var DataLayerAction;
(function (DataLayerAction) {
    DataLayerAction["CATEGORY_CLICK"] = "category_click";
    DataLayerAction["BACK_CLICK"] = "back_click";
    DataLayerAction["LINK_CLICK"] = "link_click";
    DataLayerAction["MENU_CLICK"] = "menu_click";
    DataLayerAction["FOOTER_CLICK"] = "footer_click";
})(DataLayerAction || (DataLayerAction = {}));
/**
 * @internal
 */
export const DataLayerActionInterface = docgenEnum('DataLayerAction', DataLayerAction);
var DataLayerCategory;
(function (DataLayerCategory) {
    DataLayerCategory["MENU"] = "menu";
    DataLayerCategory["FOOTER"] = "footer";
})(DataLayerCategory || (DataLayerCategory = {}));
/**
 * @internal
 */
export const DataLayerCategoryInterface = docgenEnum('DataLayerCategory', DataLayerCategory);
var DataLayerLabel;
(function (DataLayerLabel) {
    DataLayerLabel["MENU_OPEN"] = "menu_open";
    DataLayerLabel["MENU_CLOSED"] = "menu_closed";
    DataLayerLabel["MENU_BACK"] = "menu_back";
    DataLayerLabel["MENU_LINK_CLICK"] = "menu_link_click";
    DataLayerLabel["LOGIN"] = "sign_in";
})(DataLayerLabel || (DataLayerLabel = {}));
/**
 * @internal
 */
export const DataLayerLabelInterface = docgenEnum('DataLayerLabel', DataLayerLabel);
var DataLayerSection;
(function (DataLayerSection) {
    DataLayerSection["WEB_SECTION_FOOTER"] = "web-section-footer";
})(DataLayerSection || (DataLayerSection = {}));
/**
 * @internal
 */
export const DataLayerSectionInterface = docgenEnum('DataLayerSection', DataLayerSection);
export { DataLayerAction, DataLayerCategory, DataLayerEvent, DataLayerLabel, DataLayerSection };
